(function () {
  angular
    .module('MktzapApp.Controllers')
    .controller('JobsController', JobsController);

  JobsController.$inject = [];

  function JobsController () {
    var vm = this

    vm.tabs = {
      'workers': 'workers'
    }

    vm.tabSelected = 'workers'

    vm.changeTab = (tab) => {
      vm.tabSelected = tab
    }

    vm.setActiveTab = (tab) => {
      if (vm.tabSelected == tab) {
        return 'primary'
      } else {
        return 'secondary'
      }
    }
  }
})();
